var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
module.exports = function(el) {
	var $el = $(el);
	var form = $el.closest('form');

	$(el).find('.js-delete').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.js-row').find('.js-quantity .js-field-mobile').remove();
		form.submit();
	});
};
